export enum ConnectionMethod {
    Persistent = "P",
    LongPoll = "L",
}
